import React, { useState } from 'react'
import { useCustomParams } from '../../../../hooks/useCustomParams';
import { useQueryClient } from '@tanstack/react-query';
import Heading from '../../../../components/Heading';
import { Box, Divider, Stack } from '@mui/material';
import GlobalSearch from '../../../../components/Search';
import Table from "./Building/Table";
import BackButton from '../../../../components/BackButton';
import PrimaryButton from '../../../../components/Button/Button';
import AddIcon from "@mui/icons-material/Add";
import LongFormDialog from '../../../../components/Dialog/LongFormDialog';
import { useParams } from 'react-router-dom';
import { useClientDetail } from '../../../../reactQuery/client';
import CreateBuilding from './Building/CreateBuilding';
import ClientDetails from './ClientDetails';
import { useSelector } from 'react-redux';

function ClientBuildings() {
    const [anchorEl2, setAnchorEl2] = useState(false);
     const params = useParams();
     const role = JSON.parse(localStorage.getItem("userData")).role;
     const { totalUnits, totalRecords } = useSelector(state => state.buildingStats);
     
       const { responseData, isLoading, isError, error } = useClientDetail(
         params.clientId
       );
  return (
    <div>
      <Stack spacing={2}>
        <Heading title="All Buildings">
          <Stack direction="row" alignItems="center" spacing={2}>
            {role != "client" && (
              <PrimaryButton
                variant="contained"
                className={`capitalize btn-bg-blue-primary`}
                onClick={() => setAnchorEl2(true)}
                startIcon={<AddIcon />}
              >
                Add Building
              </PrimaryButton>
            )}
            <BackButton />
          </Stack>
        </Heading>
        <ClientDetails />
      </Stack>
      <div className="tickets-filter d-flex justify-content-space-between mt-4 bg-white">
        <Stack direction="row" spacing={2} alignItems="center">
          <GlobalSearch />
        </Stack>
        <Box className="d-flex">
          <Box className="mr-4">
            <p className="bottom-detail">
              {totalRecords} Buildings
            </p>
          </Box>

          <Divider orientation="vertical" flexItem />

          <Box className="ml-4">
            <p className="bottom-detail">{totalUnits} Units</p>
          </Box>
        </Box>
      </div>
      <Table />
      {anchorEl2 && (
        <LongFormDialog
          open={anchorEl2}
          handleClose={() => setAnchorEl2(false)}
          title={"Add Building Setup"}
          btnTitle={"Confirm"}
        >
          <CreateBuilding
            onClose={() => setAnchorEl2(false)}
            id={params.clientId}
            clientName={responseData?.company_name}
          />
        </LongFormDialog>
      )}
    </div>
  );
}

export default ClientBuildings